import { NavBar } from './NavBar'


const Header = () => {
  return (
        <NavBar />
  )
}

export default Header